module.exports = __webpack_public_path__ + "img/image17.7e7cbe0c.png";